import SimModel from "@/models/sim.model";
import CartModel from "@/models/cart.model";
import DeliveryModel from "@/models/delivery.model";
import SubscriberModel from "@/models/subscriber.model";
import PaymentDetailsModel from "@/models/payment-details.model";

import CartService from '@/services/cart.service.js'

import {
  CART_FETCH,
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_RESET,
  CART_UPDATE_CURRENT_ITEM,
  CART_UPDATE_SUBSCRIBER,
  CART_UPDATE_CURRENT_STEP,
  CART_RESET_CURRENT_ITEM
} from "../actions.type";

import { 
  CART_PUSH_CURRENT_ITEM,
  CART_SET,
  CART_SET_CURRENT_ITEM,
  CART_SET_CURRENT_STEP,
  CART_SET_REMOVE_ITEM,
  CART_CLEAR,
  CART_CLEAR_CURRENT,
  CART_UPDATE_STORAGE,
  CART_SET_SUBSCRIBER,
  CART_SET_DELIVERY_STATUS
} from "../mutations.type";


/* eslint-disable */
const state = {
  sims: [],
  current_step: 0,
  current_sim: new SimModel(),
  delivery: new DeliveryModel(), 
  payment_details: new PaymentDetailsModel(), 
  promo_code: null,
  // add_charges: null,
  checkout_status: null
};

function isEmpty(data) {
  return data == null || typeof (data) == 'undefined' || Object.keys(data).length === 0;
}

function totalSim(sim) {
  var total = 0;
  //if(isEmpty(sim)) return total;
  total += !isEmpty(sim.deal) ? sim.deal.price : 0;
  total += !isEmpty(sim.data) ? sim.data.price : 0;
  total += !isEmpty(sim.mins) ? sim.mins.price : 0;
  total += !isEmpty(sim.sms) ? sim.sms.price : 0;
  total += !isEmpty(sim.whatsApp) ? sim.whatsApp.price : 0;
  return total;
}

const getters = {
  cartTotals(state, getters) {

    var connection_fee_total = 0;
    
    var cart_total = 0;
    cart_total += getters.cartSims.reduce((sim_total, sim) => {      
      sim_total += totalSim(sim);
      connection_fee_total += sim.connection_fee;     
      return sim_total;
    }, 0)

    var delivery_total = state.delivery.is_required ? state.delivery.price : 0;

    var cart_totals = {
      total: cart_total + connection_fee_total + delivery_total,
      sub_total : {
        monthly : cart_total,
        once_off : connection_fee_total + delivery_total,
        delivery : delivery_total
      }
    }

    return cart_totals
  },
  currentTotalPrice(state) {
    return totalSim(state.current_sim);
  },
  currentSim(state) {
    return state.current_sim;
  },
  currentStep(state) {
    return state.current_step;
  },
  currentSimSubscriber(state) {
    return state.current_sim.subscriber;
  },
  cartSims(state) {
    return state.sims;
  },
  cart(state) {
    return new CartModel ({
      sims: state.sims,
      current_step: state.current_step,
      current_sim: state.current_sim,
      delivery: state.delivery,
      promo_code: state.promo_code,
      // add_charges: state.add_charges,
      checkout_status: state.checkout_status
    });
  },
};

const actions = {
  [CART_FETCH](context) {
    var cart = CartService.getCart();        
    context.commit(CART_SET, cart);
  },
  [CART_ADD_ITEM](context) {
    context.commit(CART_PUSH_CURRENT_ITEM);
    context.commit(CART_SET_DELIVERY_STATUS);
    context.commit(CART_UPDATE_STORAGE);
  },
  [CART_REMOVE_ITEM](context, sim) {
    context.commit(CART_SET_REMOVE_ITEM, sim);
    context.commit(CART_SET_DELIVERY_STATUS);
    context.commit(CART_UPDATE_STORAGE);
  },
  [CART_UPDATE_CURRENT_ITEM](context, sim) {    
    context.commit(CART_SET_CURRENT_ITEM, sim);
    context.commit(CART_UPDATE_STORAGE);
  },
  [CART_UPDATE_CURRENT_STEP](context, step) {    
    context.commit(CART_SET_CURRENT_STEP, step);
    context.commit(CART_UPDATE_STORAGE);
  },
  [CART_UPDATE_SUBSCRIBER](context, subscriber) {
    context.commit(CART_SET_SUBSCRIBER, subscriber);
    context.commit(CART_UPDATE_STORAGE);
  },
  [CART_RESET_CURRENT_ITEM](context) {
    context.commit(CART_CLEAR_CURRENT);
  },
  [CART_RESET](context) {
    context.commit(CART_CLEAR);
    context.commit(CART_CLEAR_CURRENT);
    context.commit(CART_SET_DELIVERY_STATUS);
    context.commit(CART_UPDATE_STORAGE)
  },
};

const mutations = {
  [CART_SET](state, data) {
    if(data === null || typeof(data) === "undefined") return;
    state.sims = data.sims;
    state.current_step = data.current_step;
    state.current_sim = new SimModel(data.current_sim);
    state.delivery = new DeliveryModel(data.delivery);
    state.promo_code = data.promo_code;
    // state.add_charges = data.add_charges;
    state.checkout_status = data.checkout_status
  },
  [CART_SET_CURRENT_ITEM](state, sim) {    
    state.current_sim = new SimModel(sim);
  },
  [CART_SET_CURRENT_STEP](state, step) {    
    state.current_step = step;
  },
  [CART_SET_REMOVE_ITEM](state, sim) {
    state.sims.splice(state.sims.indexOf(sim), 1);
  },
  [CART_PUSH_CURRENT_ITEM](state) {
    var length = state.sims.length;    
    if(isEmpty(state.current_sim.deal)) return;
    if(state.current_sim.id == 0) state.current_sim.id = ++length;
    state.sims.push(new SimModel(state.current_sim));
  },
  [CART_CLEAR](state) {
    state.sims = [];
    state.current_step = 0;
  },
  [CART_CLEAR_CURRENT](state) {
    state.current_sim = new SimModel();
    state.current_step = 0;
  },
  [CART_SET_DELIVERY_STATUS](state) {
    var require_delivery = false;
    state.sims.forEach(sim => {
      if(sim.require_delivery) {
        require_delivery = true;        
      }
    });
    state.delivery.is_required = require_delivery;
  },
  [CART_SET_SUBSCRIBER](state, subscriber) {
    state.current_sim.subscriber = new SubscriberModel(subscriber);
  },
  [CART_UPDATE_STORAGE](state) {    
    CartService.destroyCart();
    CartService.saveCart(state);
  },
};

export default {    
  state,  
  getters,
  actions,
  mutations
}